/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request for update the appointment type orders
 * @export
 * @interface AppointmentTypeOrderRequest
 */
export interface AppointmentTypeOrderRequest {
    /**
     * Unique identifier of the appointment
     * @type {string}
     * @memberof AppointmentTypeOrderRequest
     */
    appointmentTypeId?: string;
    /**
     * new appointment types order
     * @type {number}
     * @memberof AppointmentTypeOrderRequest
     */
    order?: number;
}

/**
 * Check if a given object implements the AppointmentTypeOrderRequest interface.
 */
export function instanceOfAppointmentTypeOrderRequest(value: object): value is AppointmentTypeOrderRequest {
    return true;
}

export function AppointmentTypeOrderRequestFromJSON(json: any): AppointmentTypeOrderRequest {
    return AppointmentTypeOrderRequestFromJSONTyped(json, false);
}

export function AppointmentTypeOrderRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentTypeOrderRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'appointmentTypeId': json['appointmentTypeId'] == null ? undefined : json['appointmentTypeId'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function AppointmentTypeOrderRequestToJSON(json: any): AppointmentTypeOrderRequest {
    return AppointmentTypeOrderRequestToJSONTyped(json, false);
}

export function AppointmentTypeOrderRequestToJSONTyped(value?: AppointmentTypeOrderRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'appointmentTypeId': value['appointmentTypeId'],
        'order': value['order'],
    };
}

